<span class="flex flex-col gap-2" data-test-class="receipt-item">
	@if (item().name || item().price || item().price === 0) {
		@if (item().overline) {
			<span
				class="text-xs text-dark-secondary md:text-sm"
				data-test-id="overline"
			>
				{{ item().overline }}
			</span>
		}
		<div class="flex justify-between gap-4">
			<span class="my-auto" data-test-id="receipt-item-title">
				@if (
					totalNumberOfItems() > 1 &&
					item().accommodationTypes?.length
				) {
					<span data-test-id="receipt-item-counter">
						{{
							item().accommodationTypes
								| accommodationType
								| translate
								| capitalize
						}}
						{{ index() + 1 }}:
					</span>
				}
				@if (item().amount) {
					{{ item().amount }}
					<span aria-hidden="true">x</span>
				}
				<span data-test-id="receipt-item-name">
					@if (itemWithExtras()?.upgrade) {
						{{ 'global.original-room' | translate }}:
					}
					{{ item().name }}
				</span>
				@if (item().helperText) {
					<span class="inline text-dark-tertiary">
						<span aria-hidden="true">&bull;</span>&nbsp;<span
							data-test-id="receipt-item-helpertext"
							>{{ item().helperText }}&nbsp;</span
						>
					</span>
				}
				@if (item().moreInfo) {
					<vp-tooltip
						[alignment]="'top-start'"
						class="inline-block pb-0.5 align-middle"
						iconSize="w-4"
					>
						<span vpTooltipContent>
							{{ item().moreInfo }}
						</span>
					</vp-tooltip>
				}
			</span>

			@if (item().price || item().price === 0) {
				<div class="flex flex-row gap-2">
					@if (item().originalPrice > item().priceIncTax) {
						<div data-test-id="receipt-item-original-price">
							<s>
								{{ item().originalPrice | price: currency() }}
							</s>
						</div>
					}
					<span
						[ngClass]="{
							'font-bold':
								someItemHasExtras() && !itemWithExtras(),
						}"
						class="my-auto shrink-0"
						data-test-id="receipt-item-price"
					>
						{{ item().price | price: currency() }}
					</span>
				</div>
			}
		</div>
	}

	@if (itemWithExtras()?.upgrade; as upgrade) {
		<span
			class="flex justify-between gap-4"
			data-test-id="receipt-item-upgrade"
		>
			<span>
				{{ 'global.upgrade-to' | translate }}:
				<span data-test-id="receipt-item-upgrade-name">{{
					upgrade.name
				}}</span>
			</span>
			<span
				class="my-auto shrink-0"
				data-test-id="receipt-item-upgrade-price"
			>
				{{ upgrade.price | price: currency() }}
			</span>
		</span>
	}

	@if (itemWithExtras()?.extras?.length) {
		<ul class="flex flex-col gap-1">
			@for (extra of itemWithExtras().extras; track extra) {
				<li>
					<vp-receipt-summary-extra
						[currency]="currency()"
						[extra]="extra"
					/>
				</li>
			}
		</ul>
	}

	@if (item().additionalCharges) {
		<span
			class="flex justify-between gap-4"
			data-test-class="receipt-item-additional-charges"
		>
			<span data-test-id="receipt-item-additional-charges-title">
				{{ 'global.additional-charges' | translate }}
			</span>
			<span data-test-id="receipt-item-additional-charges-price">
				{{ item().additionalCharges | price: currency() }}
			</span>
		</span>
	}

	@if (
		itemWithExtras() &&
		itemWithExtras().totalPrice &&
		totalNumberOfItems() > 1
	) {
		<div class="text-right font-bold">
			{{ addedRoomCostsTotal() | price: currency() }}
		</div>
	}

	@if (index() < totalNumberOfItems() - 1) {
		<hr class="divider h-0.5" />
	}
</span>
